import { httpCreate } from './http';

const http = httpCreate('/shop/api/product/');

export const product = {
	getProductList(userid, params) {
		return http.get(`list/user/${userid}`, { params });
	},
	getBoxProductList(userId, params) {
		return http.get(`list/forBox/${userId}`, { params });
	},
	/**
	 * 直播间商品列表
	 * @param {number} activityId 直播间id
	 */
	getActivityProductList(activityId, params) {
		return http.get(`list/activity/${activityId}`, { params });
	},
};
